import PropTypes from 'prop-types';
import HeaderBarMobile from '@/components/app/Headers/HeaderBarMobile';
import { classes } from '@/helpers/styling';
import { satisfiesBrowser } from '@/helpers/browser';
import Text from '@/components/component-library/Text';

const ChannelMobileHeader = ({
  active,
  title
}) => {
  const isSafari = satisfiesBrowser({ safari: '>0' });

  return (
    <HeaderBarMobile
      { ...(isSafari ? { key: active } : {}) }
      center={ (
        <Text
          bold className={ classes('channel-header-title', { '--is-active': active }) }
          useHeaderFont
        >
          { title }
        </Text>
      ) }
      className={ classes('mob__header-bar', { '--is-active': active }) }
    />
  );
};

ChannelMobileHeader.propTypes = {
  active: PropTypes.bool,
  title: PropTypes.string
};

ChannelMobileHeader.defaultProps = {
  active: false,
  title: ''
};

export default ChannelMobileHeader;